import { BrowserRouter,Routes,Route } from "react-router-dom";
import React from 'react'
import Header from "../pages/Header";
import Article from "../components/Article";
import Product from "../components/Product";
import Contact from "../components/Contact";
import Certificate from "../components/Certificate";
import ProductDetails from "../components/ProductDetails";
import Skills from "../components/Skills";

function AppRouter() {
  return (
    <BrowserRouter>
    <Header/>
      <Routes>
          <Route path="/" exact element={<Article/>}/>
          <Route path="/product" element={<Product/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/certificate" element={<Certificate/>}/>
          <Route path="/product/detail" element={<ProductDetails/>}/>
          <Route path="/skills" element={<Skills/>}/>
      </Routes>
    </BrowserRouter>
  )
}

export default AppRouter


